import { reduxForm } from 'redux-form'
import onSubmit from './onSubmit'

export interface ILoginFormValues {
  email: string
}

export default reduxForm<ILoginFormValues, {}>({
  destroyOnUnmount: false,
  enableReinitialize: false,
  form: 'passwordResetForm',
  onSubmit,
})
